import React from 'react';
import { author_profileOf } from '@paraglide/messages';
import { Avatar } from '@edusense/entities-media';
import { TimeDisplay } from '@edusense/shared-ui-kit/atoms/data/TimeDisplay/TimeDisplay';
// Import new styles
import { AuthorContainer, AvatarWrapper, InfoContainer, NameContainer, NameText, UsernameText, TimestampWrapper, VerifiedIcon, FeaturedIcon, AdditionalContentWrapper } from './AuthorDisplay.styles'; // Remove .tsx extension
/**
 * AuthorDisplay 컴포넌트 - 작성자 정보를 표시하는 공통 컴포넌트
 * 
 * 아토믹 디자인의 분자(Molecule) 레벨 컴포넌트
 * SocialHeader와 ProjectCard에서 공통으로 사용하기 위한 컴포넌트
 */ var AuthorDisplay = function(param) {
    var author = param.author, createdAt = param.createdAt, _param_size = param.size, size = _param_size === void 0 ? 'md' : _param_size, _param_showTimestamp = param.showTimestamp, showTimestamp = _param_showTimestamp === void 0 ? true : _param_showTimestamp, _param_isFeatured = param.isFeatured, isFeatured = _param_isFeatured === void 0 ? false : _param_isFeatured, _param_timeFormat = param.timeFormat, timeFormat = _param_timeFormat === void 0 ? 'relative' : _param_timeFormat, _param_hideAvatar = param.hideAvatar, hideAvatar = _param_hideAvatar === void 0 ? false : _param_hideAvatar, _param_layout = param.layout, layout = _param_layout === void 0 ? 'stacked' : _param_layout, _param_variant = param.variant, variant = _param_variant === void 0 ? 'default' : _param_variant, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, children = param.children;
    // 디버깅용 로그 - 프로덕션에서는 제거 예정
    console.log('AuthorDisplay props:', {
        author: author,
        layout: layout,
        hasUsername: !!author.username,
        username: author.username
    });
    // Removed Tailwind size mapping objects
    // Avatar size mapping remains as it's for the Avatar component prop
    var avatarSizeMap = {
        'xs': 'xs',
        'sm': 'sm',
        'md': 'md',
        'lg': 'lg',
        'xl': 'xl'
    };
    var getTimeDisplayFormat = function(format) {
        return format === 'relative' ? 'relative' : 'absolute';
    };
    var getProfileImage = function() {
        var img = author.profileImage || author.avatar;
        // Filter out placeholder images if necessary
        return img && !img.includes('via.placeholder.com') ? img : undefined;
    };
    return /*#__PURE__*/ React.createElement(AuthorContainer, {
        className: className,
        layout: layout,
        hideAvatar: hideAvatar,
        size: size,
        variant: variant
    }, !hideAvatar && /*#__PURE__*/ React.createElement(AvatarWrapper, null, /*#__PURE__*/ React.createElement(Avatar, {
        username: author.username || '',
        name: author.name,
        profileImage: getProfileImage(),
        size: avatarSizeMap[size],
        alt: author_profileOf({
            name: author.name
        })
    })), /*#__PURE__*/ React.createElement(InfoContainer, {
        layout: layout
    }, /*#__PURE__*/ React.createElement(NameContainer, {
        layout: layout
    }, /*#__PURE__*/ React.createElement(NameText, {
        size: size,
        variant: variant
    }, author.name), author.verified && /*#__PURE__*/ React.createElement(VerifiedIcon, {
        size: size
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z",
        clipRule: "evenodd"
    }))), isFeatured && /*#__PURE__*/ React.createElement(FeaturedIcon, null, "★"), layout === 'inline' && author.username && /*#__PURE__*/ React.createElement(UsernameText, {
        size: size,
        variant: variant
    }, "@", author.username), layout === 'inline' && showTimestamp && createdAt && /*#__PURE__*/ React.createElement(TimestampWrapper, {
        layout: layout,
        variant: variant
    }, /*#__PURE__*/ React.createElement(TimeDisplay, {
        time: createdAt,
        format: getTimeDisplayFormat(timeFormat),
        size: size
    }))), layout === 'stacked' && /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap'
        }
    }, " ", author.username && /*#__PURE__*/ React.createElement(UsernameText, {
        size: size,
        variant: variant,
        style: {
            color: '#6b7280',
            fontSize: '14px',
            fontWeight: 'normal'
        },
        "data-testid": "author-username"
    }, "@", author.username), showTimestamp && createdAt && /*#__PURE__*/ React.createElement(TimestampWrapper, {
        layout: layout,
        hasUsername: !!author.username,
        variant: variant
    }, /*#__PURE__*/ React.createElement(TimeDisplay, {
        time: createdAt,
        format: getTimeDisplayFormat(timeFormat),
        size: size
    }))), children && /*#__PURE__*/ React.createElement(AdditionalContentWrapper, null, children)));
};
export default AuthorDisplay;
